import {useFieldContext} from '../../utils/formContext';

import {TextInput} from './TextInput';

type Props = Omit<
  React.ComponentProps<typeof TextInput>,
  'name' | 'value' | 'onChange' | 'onBlur' | 'error'
>;
export function FormTextInput(props: Props): React.JSX.Element {
  const field = useFieldContext<string>();

  return (
    <TextInput
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={field.state.meta.errors.map((e) => e.message).join(', ')}
    />
  );
}
